import { useCallback, useRef, useState } from "react";

// Adds a fade-up reveal when element enters viewport.
// Uses a callback ref so the observer also attaches for components that mount
// AFTER async data arrives (e.g. the Blog/Articles section on the landing page).
export default function useReveal(threshold = 0.15) {
  const [shown, setShown] = useState(false);
  const obsRef = useRef(null);

  const ref = useCallback(
    (node) => {
      if (obsRef.current) {
        obsRef.current.disconnect();
        obsRef.current = null;
      }
      if (node) {
        const obs = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setShown(true);
                obs.disconnect();
              }
            });
          },
          { threshold }
        );
        obs.observe(node);
        obsRef.current = obs;
      }
    },
    [threshold]
  );

  return { ref, cls: `gp-fade ${shown ? "gp-in" : ""}` };
}
